// OrganisationRegistrationForm.tsx
import React, { useCallback, useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import moment from "moment";
import { organizationService } from "../lib/api/organization";
import { commonService } from "../lib/api/common";
//@ts-ignore
import Files from "react-files";
import { ReactFilesFile } from "../types/files";
import { isLessThanTheMB } from "../lib/utils/lessthan-max-filesize";
import { Messages } from "../lib/constants/messages";
import { Modal, Button } from "react-bootstrap";
import { routes } from "../routes/routes-names";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../assets/styles/organisation-registration.css"; // <- new CSS

const OrganisationRegistrationForm: React.FC = () => {
  const navigate = useNavigate();
  const [certificate, setCertificate] = useState<{ file?: File; error?: string } | null>(null);
  const [letter, setLetter] = useState<{ file?: File; error?: string } | null>(null);
  const [sheet, setSheet] = useState<{ file?: File; error?: string } | null>(null);
  const [showPreview, setShowPreview] = useState(false);

  const [previewFiles] = useState<{ [key: string]: string }>({});
  const [orgName, setOrgName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgMobile, setOrgMobile] = useState("");
  const [orgStatus, setOrgStatus] = useState<null | string>(null);
  const [orgTypes, setOrgTypes] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [countries, setCountries] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedCntry, setSelectedCntry] = useState('');
  const [states, setStates] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedCiti, setSelectedCiti] = useState('');

  const initialValues = {
    organizationType: "",
    registrationNumber: "",
    address: "",
    city: "",
    state: "",
    country: "",
    registartionCertificate: "",
    coveringLetter: "",
    declarationSheet: "",
    bankAccountNumber: "",
    bankBranchNumber: "",
    bankIfscCode: ""
  };

  const [previewData, setPreviewData] = useState<typeof initialValues | null>(null);

  const validationSchema = Yup.object().shape({
    organizationType: Yup.string().required("Required"),
    registrationNumber: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
    registartionCertificate: Yup.mixed().required("Required"),
    coveringLetter: Yup.mixed().required("Required"),
    declarationSheet: Yup.mixed().required("Required")
  });

  const getOrgDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "organization_type" } });
      setOrgTypes(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);

  const getCntryDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "country" } });
      setCountries(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);

  useEffect(() => {
    const orgData = localStorage.getItem("orgdata");
    if (orgData) {
      const retrievedObject = JSON.parse(orgData);
      setOrgName(retrievedObject.organizationName || "");
      setOrgEmail(retrievedObject.email || "");
      setOrgMobile(retrievedObject.contactNumber || "");
      if(retrievedObject.paymentStatus&&retrievedObject.paymentStatus!==undefined &&retrievedObject.paymentStatus!== null){
        setOrgStatus(retrievedObject.paymentStatus);
      }
    }
    getOrgDropDownDetails();
    getCntryDropDownDetails();
  }, []);

  const handlePreview = (values: typeof initialValues) => {
    setPreviewData(values);
    setShowPreview(true);
  };

  const handleFinalSubmit = useCallback(
    async (values: typeof initialValues) => {
      if (!previewData) return;
      try {
        const orgData = localStorage.getItem("orgdata");
        if (orgData) {

          const retrievedObject = JSON.parse(orgData);
          const orgPrimaryId = retrievedObject.id;
          const selectedState = states.find(item => item.id === parseInt(values.state));
        const stateName = selectedState?.dropdownValue || "";
        const selectedCountry = countries.find(item => item.id === parseInt(values.country));
        const countryName = selectedCountry?.dropdownValue || "";
          const organizationInfo = {
            ...values,
            id: orgPrimaryId,
            state:stateName,
            country:countryName,
            createdon: moment().format("YYYY-MM-DD"),
            posttime: moment().format("h:mm:ss")
          };

          const formData = new FormData();
          formData.append("organizationInfo", JSON.stringify(organizationInfo));
          if (certificate?.file) formData.append("registartionCertificate", certificate.file);
          if (letter?.file) formData.append("coveringLetter", letter.file);
          if (sheet?.file) formData.append("declarationSheet", sheet.file);

          const { success } = await organizationService.registration(formData);
          if (success) {
            setShowPreview(false);
            Swal.fire({
              title: "Success",
              text: "Organization created successfully",
              icon: "success",
              confirmButtonText: "OK"
            }).then((result) => {

              if (result.isConfirmed) {
                 Swal.fire({
                    text: "You will be redirected to Login page",
                    icon: "warning",
                    confirmButtonText: "OK"
                  }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(routes.index);
                    }
              });
            }});           
          }
        }
      } catch (err) {
        Swal.fire({
          text: "Organization creation failed",
          icon: "error",
          confirmButtonText: "OK"
        });
        console.error("error in organization creation", err);
      }
    },
    [certificate, letter, sheet, previewData, navigate]
  );

  // helper to handle file selection (keeps DRY)
  const handleFileChange = (files: ReactFilesFile[], setter: any, fieldName: string, setFieldValue: any) => {
    if (!files || !files[0]) return;
    const file = files[0];
    const isLess = isLessThanTheMB(files[0].size, 0.5);
    if (isLess) {
      setter({ file });
      setFieldValue(fieldName, file.name);
    } else {
      alert(Messages.isLessThanTheMB);
    }
  };

  
    const handleCountryChange = async (countryId: any) => {
      
      const selectedCountry = countries.find(item => item.id === countryId);
      const countryName = selectedCountry?.dropdownValue || "";
      setSelectedCntry(countryName);
  
  
      const { success, data } = await commonService.getDropDownValuesByParentId({
        params: { dropDownName: "state", parentId: countryId },
      });
  
      if (success) {
        setStates(data);
      }
    };
  
  
    const handleStateChange = async (stateId: any) => {
      
      const result = states.find(item => item.id === parseInt(stateId));
     const stateName = result?.dropdownValue || "";
      setSelectedState(stateName);
      const { success, data } = await commonService.getDropDownValuesByParentId({
        params: { dropDownName: "city", parentId: stateId },
      });
  
      if (success) {
        setCities(data);
      }
    };

  return (
    <div className="glass-page event-page">
      <div className="form-card" style={{ width: "100%", maxWidth: 1280 }}>
        <h2 style={{ textAlign: "center", marginBottom: 18, fontWeight: 700 }}>
          Organisation Registration For CPD Programmes
        </h2>

          {orgStatus === null ? (
            <div className="org-form-wrap">
              <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handlePreview}>
                {({ setFieldValue, values, errors, touched }) => (
                  <Form>
                    <div className="org-info-row">
                      <div className="org-info-item"><b>Organization Name:</b><span>{orgName}</span></div>
                      <div className="org-info-item"><b>Contact Number:</b><span>{orgMobile}</span></div>
                      <div className="org-info-item"><b>Email:</b><span>{orgEmail}</span></div>
                    </div>

                    <div className="grid-3">
                      <div className="form-group">
                        <label className="org-info-item">Organization Type *</label>
                        <Field as="select" name="organizationType" className="input-select">
                          <option value="">-- Select --</option>
                          {orgTypes.map((type) => (
                            <option key={type.id} value={type.dropdownValue}>
                              {type.dropdownValue}
                            </option>
                          ))}
                        </Field>
                        <div className="text-danger small"><ErrorMessage name="organizationType" /></div>
                      </div>

                      <div className="form-group fs-15">
                        <label className="org-info-item">Organization Registration <br /> Number *</label>
                        <Field name="registrationNumber" className="input-text" />
                        <div className="text-danger small"><ErrorMessage name="registrationNumber" /></div>
                      </div>

                      <div className="form-group">
                        <label className="org-info-item">Address for Communication *</label>
                        <Field name="address" className="input-text" />
                        <div className="text-danger small"><ErrorMessage name="address" /></div>
                      </div>
                    </div>

                    
                      <div className="row mb-3 pt-3">
                                          <div className="col-md-4">
                        <label className="org-info-item"> Country *</label>
                        <Field name="country">
                          {({ field, form }: any) => (
                            <select
                              {...field} // Spreads name, value, onBlur, etc.
                              className="form-select"
                              onChange={(e) => {
                                const countryId = parseInt(e.target.value);
                                // 1. Manually update Formik's value for THIS field
                                form.setFieldValue("country", countryId);
                      
                                // 2. Reset dependent fields in Formik state
                                form.setFieldValue("state", "");
                                form.setFieldValue("city", "");
                      
                                // 3. Clear local state for dependent dropdowns
                                setStates([]);
                                setCities([]);
                      
                                // 4. Trigger any external side effects (e.g., fetching new states)
                                handleCountryChange(countryId);
                              }}
                            >
                              <option value="">-- Select Country --</option>
                              {countries.map((c) => (
                                <option key={c.id} value={c.id}>
                                  {c.dropdownValue}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                        <div className="text-danger small"><ErrorMessage name="country" /></div>
                      
                      
                                        </div>
                                        <div className="col-md-4">
                                          <label className="org-info-item"> State *</label>
                                          <Field name="state">
                                            {({ field, form }: any) => (
                                              <select
                                                {...field}
                                                className="form-select"
                                                disabled={!states.length}
                                                onChange={async (e) => {
                                                  let stateId = e.target.value;
                                                  form.setFieldValue("state", stateId);
                                                  form.setFieldValue("city", "");
                                                  handleStateChange(stateId);
                                                }}
                                              >
                                                <option value="">-- Select State --</option>
                                                {states.map((s) => (
                                                  <option key={s.id} value={s.id}>
                                                    {s.dropdownValue}
                                                  </option>
                                                ))}
                                              </select>
                                            )}
                                          </Field>
                                          <div className="text-danger small"><ErrorMessage name="state" /></div>
                                        </div>
                      
                      
                                        <div className="col-md-4">
                                          <label className="org-info-item"> District  *</label>
                                          <Field as="select" name="city" className="form-select" disabled={!cities.length}>
                                            <option value="">-- Select District  --</option>
                                            {cities.map((c) => (
                                              <option key={c.id} value={c.dropdownValue}>
                                                {c.dropdownValue}
                                              </option>
                                            ))}
                                          </Field>
                                          <ErrorMessage name="city" component="div" className="text-danger" />
                                        </div>
                                      </div>
                    <div className="grid-3">
                      <div className="form-group">
                        <label className="org-info-item">Organization Bank Account Number</label>
                        <Field name="bankAccountNumber" type="text" className="input-text" />
                      </div>

                      <div className="form-group">
                        <label className="org-info-item">Organization Bank Branch Number</label>
                        <Field name="bankBranchNumber" type="text" className="input-text" />
                      </div>

                      <div className="form-group">
                        <label className="org-info-item">Organization Bank IFSC Code</label>
                        <Field name="bankIfscCode" type="text" className="input-text" />
                      </div>
                    </div>

                    <div className="upload-guidance">
                      <div>Please upload images / pdfs (.jpeg, .png, .pdf) only, &lt; 500 KB.</div>
                      <div>File name should not contain special characters and must be &lt; 20 characters.</div>
                    </div>

                    <div className="upload-row">
                      <div className="upload-col">
                        {values.registartionCertificate ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {certificate?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setCertificate(null);
                                setFieldValue("registartionCertificate", "");
                              }}
                              aria-label="Remove registration certificate"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setCertificate, "registartionCertificate", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload registration Certificate</div>
                            </div>
                          </Files>
                        )}
                        {errors.registartionCertificate && touched.registartionCertificate && (
                          <div className="text-danger small">{errors.registartionCertificate}</div>
                        )}
                      </div>

                      <div className="upload-col">
                        {values.coveringLetter ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {letter?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setLetter(null);
                                setFieldValue("coveringLetter", "");
                              }}
                              aria-label="Remove covering letter"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setLetter, "coveringLetter", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload Covering Letter</div>
                            </div>
                          </Files>
                        )}
                        {errors.coveringLetter && touched.coveringLetter && (
                          <div className="text-danger small">{errors.coveringLetter}</div>
                        )}
                      </div>

                      <div className="upload-col">
                        {values.declarationSheet ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {sheet?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setSheet(null);
                                setFieldValue("declarationSheet", "");
                              }}
                              aria-label="Remove declaration sheet"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setSheet, "declarationSheet", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload declaration Sheet</div>
                            </div>
                          </Files>
                        )}
                        {errors.declarationSheet && touched.declarationSheet && (
                          <div className="text-danger small">{errors.declarationSheet}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-actions">
                      <button type="submit" className="btn-submit">Submit</button>
                    </div>

                    {/* Preview Modal */}
                    <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Preview Organization Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {previewData && (
                          <div className="preview-grid">
                            <p><strong>Organization Name:</strong> {orgName}</p>
                            <p><strong>Email:</strong> {orgEmail}</p>
                            <p><strong>Mobile No:</strong> {orgMobile}</p>
                            <p><strong>Organization Type:</strong> {previewData.organizationType}</p>
                            <p><strong>Registration Number:</strong> {previewData.registrationNumber}</p>
                            <p><strong>Address:</strong> {previewData.address}</p>
                            <p><strong>City:</strong> {previewData.city}</p>
                            <p><strong>State:</strong> {selectedState}</p>
                            <p><strong>Country:</strong> {selectedCntry}</p>
                            <p><strong>Bank A/C:</strong> {previewData.bankAccountNumber}</p>
                            <p><strong>Branch No:</strong> {previewData.bankBranchNumber}</p>
                            <p><strong>IFSC:</strong> {previewData.bankIfscCode}</p>
                          </div>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowPreview(false)}>Edit</Button>
                        <Button variant="success" onClick={() => handleFinalSubmit(previewData!)}>Confirm & Submit</Button>
                      </Modal.Footer>
                    </Modal>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div className="org-status-wrap">
              <div className="org-status-line">
                <span className="org-status-label">Organization status is:</span>
                <span className="org-status-value">
                  {orgStatus === "pen" && "Pending"}
                  {orgStatus === "rej" && "Rejected"}
                  {orgStatus === "ver" && "Verified"}
                  {orgStatus === "apr" && "Approved"}
                </span>
              </div>

              {orgStatus === "apr" && (
                <div className="org-status-details">
                  <div><b>Organization Name:</b> {orgName}</div>
                  <div><b>Organization Email:</b> {orgEmail}</div>
                </div>
              )}

              {orgStatus === "rej" && (
                <div className="org-status-actions">
                  <Link to="/mainLayout/edit-organization" className="btn btn-primary btn-sm">
                    Edit
                  </Link>
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

export default OrganisationRegistrationForm;
